require('./upload-directive-template.html');

angular.module('bbl.module.line-settings')
  .directive('uploadFileInput', ['Toast', '$http', 'ENV', FileInputFactory]);

var uploadHeaders = {
  transformRequest: angular.identity,
  headers: { 'Content-Type': undefined },
};

function FileInputFactory(Toast, $http, env) {
  var UPLOAD_SIZE_LIMIT = env.UPLOAD_SIZE_LIMIT;

  return {
    restrict: 'EA',
    templateUrl: 'upload-directive-template.html',

    scope: {
      type: '=',
      bridge: '=',
      model: '=',
      file: '=',
      onChange: '&',
      onUploading: '&',
    },

    link: function($scope, $el, $atts) {
      $scope.single = !Array.isArray($scope.model);
      $scope.uploading = false;

      $scope.MODEL = angular.copy($scope.model || {});

      if($scope.file && !$scope.model) {
        $scope.MODEL = angular.copy($scope.file);
      }

      $scope.uploadFile = function(files, input) {
        var file = files[0];
        var isMp3File = file.type.match(/audio\/mp3/i) || file.name.match(/\.mp3$/i);
        if(!isMp3File) {
          input.value = ''; // clear input
          return Toast.error('Only mp3 files are allowed!');
        }

        if (files[0].size > UPLOAD_SIZE_LIMIT) {
          input.value = ''; // clear input
          return Toast.error('Max upload size limit is 120MB!');
        }

        $scope.onChange();

        for (var i = 0; i < files.length; i++) {
          var fd = new window.FormData();

          fd.append("file", files[i]);
          fd.append("bridge_id", $scope.bridge);
          fd.append("type", $scope.type);

          uploadHandler(fd);
        }

        input.value = ''; // clear input
      };

      function uploadHandler(fd) {
        $scope.onUploading({$event: $scope.uploading = true});

        // $("#saveSettings").text("Save changes");
        Toast.notify("Uploading files, please wait...", {uid: 'upload-input-file'});

        return $http.post('/bridges/upload-file', fd, uploadHeaders).then(function(response) {
          var file = {
            id: response.data.id,
            url: response.data.url,
            name: response.data.name,
          };

          if ($scope.single) {
           angular.extend($scope.MODEL, file);
          } else {
            $scope.MODEL.push(file);
          }

          Toast.notify("File uploaded successfully!", {uid: 'upload-input-file'});
        }, Toast.error.bind(Toast, 'Something went wrong!')).then(function() {
          $scope.onUploading({$event: $scope.uploading = false});
        });
      }

      $scope.removeFile = function(file_id) {
        $scope.onChange();

        var fd = new window.FormData();
        fd.append("file_id", file_id);

        $http.post('/bridges/remove-file', fd, uploadHeaders).then(function() {
          $scope.MODEL = $scope.MODEL.filter(function(m) {
            return m.id !== file_id;
          });
        }, Toast.error.bind(Toast, 'Something went wrong!'));
      };
    }
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/line-settings/upload-directive/upload.directive.js
 ** module id = 352
 ** module chunks = 0
 **/